import type {
  LalKitabKundliRequest,
  LalKitabKundliResponse,
  PlanetEffect,
  ActiveRemedy,
  DetectedDebt,
  LalKitabSummary,
  PlanetRemedyDetail,
} from "@ishvaram/api-client";
export type {
  LalKitabKundliRequest,
  LalKitabKundliResponse,
  PlanetEffect,
  ActiveRemedy,
  DetectedDebt,
  LalKitabSummary,
  PlanetRemedyDetail,
};
import { apiRequest } from "./_fetch";

export async function calculateLalKitabKundli(
  data: LalKitabKundliRequest
): Promise<LalKitabKundliResponse> {
  return apiRequest<LalKitabKundliResponse>("/lal-kitab-kundli", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function getLalKitabPlanetRemedies(planetSlug: string): Promise<PlanetRemedyDetail> {
  return apiRequest<PlanetRemedyDetail>(`/lal-kitab-remedies/${planetSlug}`);
}
